module.exports = "/images/embed.svg?a83ac17d37e4a35dad1db525dc39a456";